import React, { useContext, useEffect, useState } from 'react'
import '../../components/template/template.scss'
import RowingHeroSection from '../../components/template/rosemary/rowingHeroSection'
import AsymmetricFlow from '../../components/template/rosemary/asymmetricFlow'
import PromotionalLead from '../../components/template/rosemary/promotionalLead'
import PassimCarve from '../../components/template/rosemary/passimCarve'
import InventorySlide from '../../components/template/rosemary/inventorySlide'
import ClassyBanners from '../../components/template/fitness/classyBanners'
import NarrowAdmonition from '../../components/template/fitness/narrowAdmonition'
import DefinityCards from '../../components/template/fitness/definityCards'
import FineTunedGallery from '../../components/template/fitness/fineTunedGallery'
import FlyerIntro from '../../components/template/fitness/flyerIntro'
import MementoSlides from '../../components/template/fitness/mementoSlides'
import WedgedInfo from '../../components/template/fitness/wedgedInfo'
import DecomposedBanners from '../../components/template/gaming/decomposedBanners'
import ExtensiveCarouselRendition from '../../components/template/gaming/extensiveCarouselRendition'
import AdNCarousel from '../../components/template/gaming/adNCarousel'
import ExtensiveCarouselSimple from '../../components/template/gaming/extensiveCarouselSimple'
import TripleCardCarousel from '../../components/template/gaming/tripleCardCarousel'
import BobbingCards from '../../components/template/gaming/bobbingCards'
import DefaultBanner from '../../components/template/default/defaultBanner'
import DefaultSwimlane from '../../components/template/default/defaultSwimlane'
import DefaultArtistSwimlane from '../../components/template/default/defaultArtistSwimlane'
import DefaultVenueSwimlane from '../../components/template/default/defaultVenueSwimlane'
import { AppContext } from '../../context/app'
import useAxios from 'axios-hooks'
import { CUSTOM_PAGES_API } from '../../apiUrls'
import { useLocation, useNavigate, useParams } from 'react-router'
import { withTheme } from 'theming'
import ReactHtmlParser from 'react-html-parser'
import { isEmpty } from 'lodash'
import 'react-quill/dist/quill.snow.css'
import './customPage.css'
import PassimCarvePlayer from '../../components/template/rosemary/passimCarvePlayer'
import ClassBannerPlayer from '../../components/template/fitness/classBannerPlayer'
import DefaultBannerPlayer from '../../components/template/default/defaultBannerPlayer'

const CustomPage = ({ theme }) => {
  const pageURL = useParams().pageURL
  const location = useLocation()
  const [componentData, setComponentData] = useState([])
  const [htmlData, setHtmlData] = useState('')
  const { setLoader } = useContext(AppContext)
  const [pageData, setPageData] = useState({})
  const navigate = useNavigate()

  const [{ data: pagesList, loading: pagesListLoading }, pagesListCall] = useAxios(
    {
      url: CUSTOM_PAGES_API,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    pagesListCall()
  }, [location.pathname])

  useEffect(() => {
    setLoader(pagesListLoading)
  }, [pagesListLoading])

  useEffect(() => {
    if (pagesList && pagesList.success && pageURL) {
      if (location.pathname.split('/')[1] === 'custom') {
        let pageObj = pagesList.data.filter(
          (page) => page?.type === 'CUSTOM' && page?.page_url === `/${pageURL}`,
        )[0]
        if (!pageObj) {
          navigate('/home')
        }
        setPageData(pageObj)
        setComponentData(pageObj?.components)
      }
      if (location.pathname.split('/')[1] === 'static') {
        let pageObj = pagesList.data.filter(
          (page) => page?.type === 'STATIC' && page?.page_url === `/${pageURL}`,
        )[0]
        if (!pageObj) {
          navigate('/home')
        }
        setPageData(pageObj)
        setHtmlData(pageObj?.content)
      }
    }
  }, [pagesList])

  const getComponent = (key, data) => {
    if (!key) return
    let componentProps = {
      componentData: data,
      modifyData: () => {},
      setModalState: () => {},
      isEdit: false,
      onSwap: () => {},
      onDelete: () => {},
      onCopy: () => {},
      onAdd: () => {},
    }
    let componentObj = {
      rowingHeroSection: <RowingHeroSection {...componentProps} />,
      asymmetricFlow: <AsymmetricFlow {...componentProps} />,
      promotionalLead: <PromotionalLead {...componentProps} />,
      passimCarve: <PassimCarve {...componentProps} />,
      passimCarvePlayer: <PassimCarvePlayer {...componentProps} />,
      inventorySlide: <InventorySlide {...componentProps} />,
      classyBanners: <ClassyBanners {...componentProps} />,
      classyBannersPlayer: <ClassBannerPlayer {...componentProps} />,
      narrowAdmonition: <NarrowAdmonition {...componentProps} />,
      definityCards: <DefinityCards {...componentProps} />,
      fineTunedGallery: <FineTunedGallery {...componentProps} />,
      flyerIntro: <FlyerIntro {...componentProps} />,
      mementoSlides: <MementoSlides {...componentProps} />,
      wedgedInfo: <WedgedInfo {...componentProps} />,
      decomposedBanners: <DecomposedBanners {...componentProps} />,
      extensiveCarouselRendition: <ExtensiveCarouselRendition {...componentProps} />,
      adNCarousel: <AdNCarousel {...componentProps} />,
      extensiveCarousel: <ExtensiveCarouselSimple {...componentProps} />,
      tripleCardCarousel: <TripleCardCarousel {...componentProps} />,
      bobbingCards: <BobbingCards {...componentProps} />,
      defaultBanner: <DefaultBanner {...componentProps} />,
      defaultBannerPlayer: <DefaultBannerPlayer {...componentProps} />,
      defaultSwimlane: <DefaultSwimlane {...componentProps} />,
      artistSwimlane: <DefaultArtistSwimlane {...componentProps} />,
      venueSwimlane: <DefaultVenueSwimlane {...componentProps} />,
    }

    return componentObj[key]
  }
  return (
    <div>
      {pageData?.type === 'CUSTOM' &&
        componentData.map((info, index) => getComponent(info?.data?.component_key, info?.data))}
      {pageData?.type === 'STATIC' && (
        <div className={`bg-no-repeat bg-right bg-contain mb-15 mt-4 custom-page ql-editor `}>
          <div style={{ color: theme.c4 }} className="md:mt-8 px-8 md:px-20">
            {!isEmpty(pageData) && ReactHtmlParser(htmlData)}
          </div>
        </div>
      )}
    </div>
  )
}

export default withTheme(CustomPage)
